import { ReactNode } from 'react'
import { Box } from '@mui/material'
import useGetThemeColor from '@/hooks/useGetThemeColor'
import { WorkflowState } from '@/types/workflows'
import SettingsHeading from '@/components/shared/settings/SettingsHeading'

type WorkflowStateHeadingProps = {
  workflowState: WorkflowState
  /** One sentence about the state, like that it's the initial state. */
  description?: ReactNode
}

/**
 * The state's name, with its color, at the top of the workflow state editor,
 * above its tabs.
 */
export default function WorkflowStateHeading({
  workflowState,
  description,
}: WorkflowStateHeadingProps) {
  const getThemeColor = useGetThemeColor()

  return (
    // Page-sized, but an h2: the editor sits under the Workflow States page's
    // h1, which is visually hidden.
    <SettingsHeading
      level="page"
      component="h2"
      title={
        <Box
          component="span"
          sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}
        >
          <Box
            component="span"
            sx={{
              flexShrink: 0,
              width: 4,
              height: '0.9em',
              borderRadius: 4,
              background: getThemeColor(workflowState.color),
            }}
          />
          {workflowState.name}
        </Box>
      }
      description={description}
    />
  )
}
